var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:{ round: _vm.round },on:{"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false},"click":_vm.clicked}},[_c('i',{class:_vm.classes})])}
var staticRenderFns = []

export { render, staticRenderFns }